import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faStar, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { ChevronLeft, Trash2, X, ShoppingBag, ChevronRight, Info, MapPin, Tickets, Calendar, Dot } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits } from '../common/function';
import { changeAlramModal, changeShoppingFriend, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FallbackImage from '../common/FallbackImage';

function ShoppingBuy() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // URL 파라미터 예시 (couponId)를 받고 싶다면 useParams 사용
    const { shoppingId } = useParams();

    // navigate의 state로 전달된 쿠폰 정보
    const location = useLocation();
    const shoppingItem = location.state?.item;
    const shoppingState = location.state?.state;
    const shoppingMessage = location.state?.message;
    const friend_name = location.state?.friend_name;

    const JWT = useSelector((state) => state.JWT.value);
    const mySkin = useSelector((state) => state.mySkin);
    const shoppingFriend = useSelector((state) => state.shoppingFriend.value);

    const [message, setMessage] = useState("");

    if (!shoppingItem) {
        return (
            <div style={{ padding: "20px" }}>
                쇼핑하기
            </div>
        );
    }

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '70px', fontFamily: 'sans-serif' }}>
                <MessageModal message={message} />
                {/* 고정된 상단 헤더 */}
                <div
                    style={{
                        position: 'fixed',
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: "50px",
                        background: "#fff",
                        padding: "0 15px",
                        zIndex: "10",
                        borderBottom: "1px solid #dddddd"
                    }}
                >
                    {/* 뒤로가기 버튼 */}
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            left: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <ShoppingBag style={{ width: '23px', height: '23px' }} onClick={() => { dispatch(changeShoppingFriend(null)); navigate('/shopping') }} />
                    </div>

                    {/* 중앙 타이틀 */}
                    <div style={{ fontWeight: 'bold', color: "#000", fontSize: "18px" }}>
                        {shoppingState === 1 ? t('shopping_17') : t('shopping_16')}
                    </div>
                    <div
                        style={{
                            color: '#000',
                            cursor: 'pointer',
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        onClick={() => {
                            dispatch(changeShoppingFriend(null));;
                            navigate('/shopping')
                        }}
                    >
                        <X style={{ width: '28px', height: '28px' }} />
                    </div>
                </div>
                <div style={{ padding: "15px", marginTop: "50px", background: "#fff" }}>
                    <div style={{ margin: "0px 0 15px" }}>
                        <div style={{ position: "relative" }}>
                            <img src='/newImg/shoppingProfile.png' style={{ margin: "0 auto", height: "103px" }} />
                            <div style={{ width: "55px", height: "55px", borderRadius: "30%", margin: "0 auto", border: "1px solid #f9f9f9", position: "absolute", bottom: "5px", left: "50%", transform: "translateX(-50%)", background: "#fff" }}>
                                <img src={`/img/noItem.png`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            </div>
                        </div>
                        <div style={{ fontSize: "17px", fontWeight: "500" }}>
                            {
                                friend_name
                                    ?
                                    <>
                                        To. {friend_name} <br />
                                    </>
                                    :
                                    ""
                            }
                            {t('shopping_24_0')} {shoppingState === 1 ? t('shopping_24_1') : t('shopping_24_2')}
                        </div>
                    </div>

                    <div style={{ marginBottom: "15px", background: "#f5f5f5", borderTop: "2px solid #e1e1e1", borderBottom: "2px solid #e1e1e1", textAlign: "left" }}>
                        <div style={{ fontWeight: "500", fontSize: "14px", padding: "10px", borderBottom: "1px solid #e1e1e1" }}>
                            {t('shopping_25')}
                        </div>
                        {/* {shoppingMessage?.length > 0 && (
                            <div
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    marginTop: "10px",
                                    position: 'relative',
                                    padding: "0 10px",
                                }}
                            >
                                <div style={{
                                    width: "100%",
                                    height: "auto",
                                    padding: "15px",
                                    background: "#fff",
                                    borderRadius: '8px',
                                    color: "#000",
                                    textAlign: "left",
                                    fontSize: "14px",
                                    display: "flex",
                                    gap: "7px"
                                }}>
                                    <FontAwesomeIcon icon={faEnvelope} style={{ width: "19px", height: "19px", color: "#ffbb3f" }} />
                                    <div style={{
                                        wordBreak: "break-word",
                                        whiteSpace: "pre-wrap",
                                        flex: 1
                                    }}>
                                        "{shoppingMessage ?? ""}"
                                    </div>
                                </div>
                            </div>
                        )} */}
                        <div style={{ display: "flex", gap: "10px", padding: "10px" }}>
                            <div
                                style={{
                                    width: "75px",
                                    height: "75px",
                                    overflow: "hidden",
                                    borderRadius: "4px",
                                    border: "1px solid #f9f9f9"
                                }}
                            >
                                <FallbackImage
                                    src={shoppingItem?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${shoppingItem.ci_custom_image_filename}` : shoppingItem.ci_goods_img_big}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </div>

                            <div style={{ width: "calc(100% - 75px)", textAlign: "left" }}>
                                <div style={{ fontSize: "11px", color: "#a9a9a9", fontWeight: "500" }}>
                                    {shoppingItem.ci_brand_name}
                                </div>

                                <div className='table-overflow-2lines' style={{ fontSize: "12px", color: "#5f5f5f", fontWeight: "bold", marginBottom: "5px" }}>
                                    {shoppingItem.ci_goods_name}
                                </div>

                                <div style={{ fontSize: "12px", marginBottom: "2px", fontWeight: "bold" }}>
                                    {changeNum(shoppingItem.ci_point_price)}p
                                </div>

                                <div style={{ fontSize: "11px", color: "#a9a9a9", fontWeight: "500" }}>
                                    {t('shopping_22')}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginBottom: "30px", display: "flex", alignItems: "center", gap: "10px", fontSize: "14px", fontWeight: "bold" }}>
                        <div style={{ width: "100%", border: "1px solid #e1e1e1", padding: "10px", cursor: "pointer" }}
                            onClick={() => { dispatch(changeShoppingFriend(null)); navigate('/shoppingHistory', { state: { pre_location: "history" } }) }}>{t('shopping_26')}</div>
                        <div style={{ width: "100%", border: "1px solid #ffa500", padding: "10px", background: "#ffbb3f", cursor: "pointer" }}
                            onClick={() => { dispatch(changeShoppingFriend(null)); navigate('/coupons') }}>{t('shopping_27')}</div>
                    </div>
                </div>
                <div style={{ fontSize: "11px", color: "#a1a1a1", textAlign: "left", padding: "15px" }}>
                    <div style={{ marginBottom: "5px", display: "flex", alignItems: "center", gap: "5px" }}>
                        <Info size={14} /> <span style={{ fontWeight: "bold" }}>{t('shopping_28')}</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <Dot size={14} /> {t('shopping_29_0')} <span style={{ fontWeight: "bold", marginLeft: "4px" }}>{t('shopping_29_1')}</span>{t('shopping_29_2')}
                    </div>
                </div>
            </div>
        </div >
    );
}

export default ShoppingBuy;